import { React, useEffect, useState, useRef } from 'react';
import ModalBox from '../common/ModalBox';
import { Input, Button } from 'antd';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import { calcInputSize } from '../../utilities';

function QualificationModalBox(props) {
  const {
    selectedOtherQualification,
    setSelectedOtherQualification,
    tempOtherQualification,
    setTempOtherQualification,
    qualificationMatchPreset,
    addOtherQualificationsToList,
    addTheQualificationMatchToList,
  } = props;

  const inputRef = useRef(null);

  return (
    <ModalBox title='Enter Qualification' visible={selectedOtherQualification} setVisible={() => setSelectedOtherQualification()} className='changeModal'>
      <div>
        <div>Please enter the qualification you could not find in the list</div>
        <div className='changeModal_inputMargin'>
          <Input
            value={tempOtherQualification}
            onChange={(e) => setTempOtherQualification(e.target.value)}
            size={calcInputSize}
            placeholder='Other Qualification'
            allowClear
            ref={inputRef}
            autoComplete='off'
            prefix={<SafetyCertificateOutlined />}
          />
          {qualificationMatchPreset ? (
            <span className='text_danger'>
              Qualification exists{' '}
              <Button className='link_button' size={'small'} type='link' onClick={() => addTheQualificationMatchToList(qualificationMatchPreset)}>
                {qualificationMatchPreset}
              </Button>
            </span>
          ) : (
            ''
          )}
        </div>
        <div className='changeModal_buttons'>
          <Button onClick={() => setSelectedOtherQualification(false)} className='button_default'>
            Cancel
          </Button>
          <Button onClick={() => addOtherQualificationsToList()} disabled={tempOtherQualification.length <= 1 || qualificationMatchPreset} type='primary'>
            Submit
          </Button>
        </div>
      </div>
    </ModalBox>
  );
}

export default QualificationModalBox;
